module.exports = __webpack_public_path__ + "static/media/donbosco22.67616259.jpg";